import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  LoadingStateType,
  DefaultInitialState,
  SliceName,
} from '@/shared/config';

type AccessSliceInitialState = DefaultInitialState & {
  accessSharedWithMeCount: number;
  accessSharedByMeCount: number;
  accessTotalOrganizationPatientCount: number;
};

const initialState: AccessSliceInitialState = {
  accessSharedWithMeCount: 0,
  accessSharedByMeCount: 0,
  accessTotalOrganizationPatientCount: 0,
  loading: 'idle',
};

const accessSlice = createSlice({
  name: SliceName.access,
  initialState,
  reducers: {
    setSharedWithMeCount: (state, action: PayloadAction<number>) => {
      state.accessSharedWithMeCount = action.payload;
    },
    setSharedByMeCount: (state, action: PayloadAction<number>) => {
      state.accessSharedByMeCount = action.payload;
    },
    setTotalOrganizationPatientCount: (
      state,
      action: PayloadAction<number>,
    ) => {
      state.accessTotalOrganizationPatientCount = action.payload;
    },
    setLoading: (state, action: PayloadAction<LoadingStateType>) => {
      state.loading = action.payload;
    },
  },
});

export const { actions } = accessSlice;

export default accessSlice.reducer;
